
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("21h3i", function(module, exports) {

$parcel$export(module.exports, "messages", () => $de505ed528013fae$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $de505ed528013fae$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    // --- Prompt (Top Suggestion) ---
    promptTitle: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.prompt.heading.non-final",
        defaultMessage: "Give readers a summary video"
    },
    // --- Buttons ---
    viewScriptButton: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.button.see-script.non-final",
        defaultMessage: "See script"
    },
    recordVideoButton: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.button.record-video.non-final",
        defaultMessage: "Record video"
    },
    okButton: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.button.ok.non-final",
        defaultMessage: "Ok"
    },
    // --- AI Label ---
    aiBadgeText: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.label.powered-by-ai.non-final",
        defaultMessage: "Powered by AI"
    },
    // --- Spotlight (User Guidance Bubble) ---
    spotlightTitle: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.spotlight.title.non-final",
        defaultMessage: "Record a video anytime"
    },
    spotlightDescription: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.spotlight.description.non-final",
        defaultMessage: "Easily record and add a Loom video to your page whenever you want."
    },
    // --- Popup Card (Script Suggestion Dialog) ---
    popupTitle: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.popup.title.non-final",
        defaultMessage: "Record a Loom video"
    },
    popupPrimaryMessage: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.popup.message.main.non-final",
        defaultMessage: "Explain your key points for your readers."
    },
    popupContextNote: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.popup.message.context.non-final",
        defaultMessage: "This page contains complex content"
    },
    loonScriptValuePopupTriggerLabel: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.benefit.popup.trigger-label.non-final",
        defaultMessage: "View script value"
    },
    loomScriptJustification: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.benefit.popup.justification.non-final",
        defaultMessage: "This page takes a long time to read. Use Loom to create an easy video summary to help people get the information they need in less time."
    },
    // --- Loom Script ---
    loomScriptTitle: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.title.non-final",
        defaultMessage: "Loom video script"
    },
    loomScriptFooter: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.footer.non-final",
        defaultMessage: "Content quality may vary."
    },
    loomScriptTime: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.time.non-final",
        defaultMessage: "{time} min video estimate"
    },
    loomScriptExpandSectionTitle: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.expand-section-title.non-final",
        defaultMessage: "Why record a video for this page?"
    },
    loomScriptNeedHelpSectionTitle: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.need-help-title.non-final",
        defaultMessage: "Need help getting started?"
    },
    loomScriptWatchDemo: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.watch-demo.non-final",
        defaultMessage: "Watch a 2 minute demo"
    },
    loomScriptCopy: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.copy.non-final",
        defaultMessage: "Copy"
    },
    loomScriptCopied: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.copied.non-final",
        defaultMessage: "Copied!"
    },
    loomScriptCopyFailed: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.copy-failed.non-final",
        defaultMessage: "Copy failed"
    },
    loomScriptExpandSectionLabel: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.expand-section-label.non-final",
        defaultMessage: "Expand section"
    },
    loomScriptCollapseSectionLabel: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.collapse-section-label.non-final",
        defaultMessage: "Collapse section"
    },
    // --- Confluence read time dropdown section Loom script extension
    readTimeImprovementLabel: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.readtime.readability-label.non-final",
        defaultMessage: "Ways to improve readability"
    },
    readTimeLoomAIScriptTitle: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.readtime.loom-title.non-final",
        defaultMessage: "Create a summary Loom video"
    },
    openRecorder: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.readtime.open-recorder.non-final",
        defaultMessage: "Open recorder"
    }
});

});

parcelRegister("3MUQC", function(module, exports) {

$parcel$export(module.exports, "ViewScriptButton", () => $6a194b1b69ab8490$export$b86eab19902e37ed);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $a6IPc = parcelRequire("a6IPc");

var $ccHMk = parcelRequire("ccHMk");

var $21h3i = parcelRequire("21h3i");

var $gwFzn = parcelRequire("gwFzn");

var $jvYFk = parcelRequire("jvYFk");
var $aWwYt = parcelRequire("aWwYt");

var $21h3i = parcelRequire("21h3i");

var $gwFzn = parcelRequire("gwFzn");

var $a6IPc = parcelRequire("a6IPc");

var $bUlM5 = parcelRequire("bUlM5");
const $f636800745fc6cbd$export$970db1372f5480e2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
        label: "Loom script header"
    }));
};



var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");

var $9FnLD = parcelRequire("9FnLD");

var $9zIwY = parcelRequire("9zIwY");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $kevJM = parcelRequire("kevJM");

var $2Nwuj = parcelRequire("2Nwuj");

var $gt9HV = parcelRequire("gt9HV");

var $iZRoG = parcelRequire("iZRoG");

var $dIouf = parcelRequire("dIouf");
const $3347704b46b13fc9$export$91bfd9bdbb33b473 = {
    readTime: 3,
    videoPurposeText: 'A Loom recording would be valuable for this page as it covers a complex strategy with numerous initiatives, metrics, and terminology that may be difficult to digest quickly.\n\nA recording can help provide clarity on the strategic priorities and key focus areas, making it easier for the team to understand and align on objectives.\n\nHighlighting sections with visual aids can also make the content more engaging and accessible.',
    loomAIGeneratedScript: "Hi team, I'd like to provide some additional context on our Growth - Confluence XFlow FY25H2 Strategy Refresh.\n\n1. The first thing to understand is our focus on enhancing the cross-flow appeal between Jira and Confluence. We're investing in improving the value proposition of existing touchpoints and creating new integrations to increase signups.\n\nShow the section on 'Goals'.\n\n2. Next, we're addressing onboarding experiences to ensure new cross-flow users can effectively navigate and utilize Confluence from day one.\n\nHighlight the 'Improve the cross-flow onboarding experience' section with examples of current challenges.\n\n3. We are also working on reducing friction for users landing in Confluence, ensuring a seamless transition post-signup and enhancing engagement.\n\nDisplay the 'Reduce friction of landing in the product' section for visual reference"
};



var $21h3i = parcelRequire("21h3i");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $6R5uz = parcelRequire("6R5uz");

var $ghftu = parcelRequire("ghftu");

var $1qfLF = parcelRequire("1qfLF");

var $21h3i = parcelRequire("21h3i");
const $0c29bb563406aa26$var$containerStyles = (0, $ecnYn.xcss)({
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: 'border.radius.100',
    padding: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $0c29bb563406aa26$var$headerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050'
});
const $0c29bb563406aa26$var$headerTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $0c29bb563406aa26$var$contentStyles = (0, $ecnYn.xcss)({
    margin: 'space.050',
    paddingBlock: 'space.100',
    paddingInline: 'space.300',
    whiteSpace: 'pre-wrap',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $0c29bb563406aa26$export$82e0c0ed6d83e993 = ({ title: title, children: children })=>{
    const [expanded, setExpanded] = (0, $gwFzn.useState)(false);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $0c29bb563406aa26$var$containerStyles,
        "aria-labelledby": "loom-script-expand-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $0c29bb563406aa26$var$headerStyles,
        wrap: "nowrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        onClick: ()=>setExpanded(!expanded),
        icon: expanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))),
        "aria-expanded": expanded,
        appearance: "subtle",
        spacing: "compact",
        testId: "loom-script-expand-toggle",
        label: expanded ? formatMessage((0, $21h3i.messages).loomScriptCollapseSectionLabel) : formatMessage((0, $21h3i.messages).loomScriptExpandSectionLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c29bb563406aa26$var$headerTextStyles,
        id: "loom-script-expand-header"
    }, title)), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c29bb563406aa26$var$contentStyles,
        testId: "loom-script-expand-content"
    }, children));
};


const $467a1e0ff151d647$var$scriptContainerStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.300'
});
const $467a1e0ff151d647$var$videoLink = 'https://www.youtube.com/watch?v=example'; // Replace with actual video link
const $467a1e0ff151d647$var$scriptTimeStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.100',
    paddingInline: 'space.050',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $467a1e0ff151d647$var$loomAIGeneratedScriptStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.100',
    paddingInline: 'space.150',
    marginTop: 'space.100',
    marginBottom: 'space.100',
    whiteSpace: 'pre-wrap'
});
const $467a1e0ff151d647$var$recordVideoButtonContainerStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $467a1e0ff151d647$var$helpSectionStyles = (0, $ecnYn.xcss)({
    padding: 'space.200',
    marginTop: 'space.200',
    marginBottom: 'space.300',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'border.radius.100'
});
const $467a1e0ff151d647$var$linkWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100'
});
const $467a1e0ff151d647$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $467a1e0ff151d647$var$ScriptDuration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.025",
        wrap: "wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
        label: "Video time"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $467a1e0ff151d647$var$scriptTimeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...(0, $21h3i.messages).loomScriptTime,
        values: {
            time: (0, $3347704b46b13fc9$export$91bfd9bdbb33b473).readTime
        }
    })));
const $467a1e0ff151d647$var$LoomAIGeneratedScript = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        as: "section",
        "aria-labelledby": "ai-script-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $467a1e0ff151d647$var$loomAIGeneratedScriptStyles
    }, (0, $3347704b46b13fc9$export$91bfd9bdbb33b473).loomAIGeneratedScript));
const $467a1e0ff151d647$var$RecordVideoButton = ({ onRecordVideoClick: onRecordVideoClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $467a1e0ff151d647$var$recordVideoButtonContainerStyles,
        testId: "loom-script-panel-record-video"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        shouldFitContainer: true,
        appearance: "primary",
        testId: "loom-script-panel-record-video-button",
        onClick: ()=>onRecordVideoClick?.()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $21h3i.messages).recordVideoButton)));
const $467a1e0ff151d647$var$LoomScriptHelpSection = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        as: "section",
        "aria-labelledby": "loom-script-help-heading",
        xcss: $467a1e0ff151d647$var$helpSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $21h3i.messages).loomScriptNeedHelpSectionTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $467a1e0ff151d647$var$linkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        href: $467a1e0ff151d647$var$videoLink,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $21h3i.messages).loomScriptWatchDemo))));
const $467a1e0ff151d647$var$CopyButton = ()=>{
    const [copied, setCopied] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(false);
    const handleCopy = async ()=>{
        try {
            await navigator.clipboard.writeText((0, $3347704b46b13fc9$export$91bfd9bdbb33b473).loomAIGeneratedScript);
            setCopied(true);
            setError(false);
        } catch  {
            setCopied(false);
            setError(true);
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        if (copied || error) {
            const timer = setTimeout(()=>{
                setCopied(false);
                setError(false);
            }, 2000);
            return ()=>clearTimeout(timer);
        }
    }, [
        copied,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $467a1e0ff151d647$var$iconWrapperStyles,
        testId: "loom-script-copy-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gt9HV))),
        appearance: "subtle",
        onClick: handleCopy
    }, copied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $21h3i.messages).loomScriptCopied) : error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $21h3i.messages).loomScriptCopyFailed) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $21h3i.messages).loomScriptCopy)));
};
const $467a1e0ff151d647$var$FeedbackGroup = ()=>{
    const [thumbs, setThumbs] = (0, $gwFzn.useState)(undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050",
        wrap: "nowrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))),
        label: "Thumbs Up",
        testId: "import-feedback-banner-thumbs-up-button",
        onClick: ()=>{
            if (thumbs === 'up') setThumbs(undefined); // Toggle off if already selected
            else setThumbs('up');
        },
        isSelected: thumbs === 'up',
        "aria-pressed": thumbs === 'up' ? 'true' : 'false'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))),
        label: "Thumbs Down",
        testId: "import-feedback-banner-thumbs-down-button",
        onClick: ()=>{
            if (thumbs === 'down') setThumbs(undefined); // Toggle off if already selected
            else setThumbs('down');
        },
        isSelected: thumbs === 'down',
        "aria-pressed": thumbs === 'down' ? 'true' : 'false'
    }));
};
const $467a1e0ff151d647$var$LoomScriptPanelBodyComponent = ({ onRecordVideoClick: onRecordVideoClick })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $467a1e0ff151d647$var$scriptContainerStyles,
        testId: "loom-script-panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($467a1e0ff151d647$var$ScriptDuration, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $0c29bb563406aa26$export$82e0c0ed6d83e993), {
        title: intl.formatMessage((0, $21h3i.messages).loomScriptExpandSectionTitle)
    }, (0, $3347704b46b13fc9$export$91bfd9bdbb33b473).videoPurposeText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($467a1e0ff151d647$var$LoomAIGeneratedScript, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($467a1e0ff151d647$var$CopyButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($467a1e0ff151d647$var$FeedbackGroup, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($467a1e0ff151d647$var$LoomScriptHelpSection, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iZRoG.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($467a1e0ff151d647$var$RecordVideoButton, {
        onRecordVideoClick: onRecordVideoClick
    }));
};
const $467a1e0ff151d647$export$d6971ade7b0a7157 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).GROWTH_MULTIPLIERS
})($467a1e0ff151d647$var$LoomScriptPanelBodyComponent);



var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $3Mg7y = parcelRequire("3Mg7y");

var $8tSmd = parcelRequire("8tSmd");

var $21h3i = parcelRequire("21h3i");
const $4857f330d8ce7f4c$var$scriptFooterStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.100',
    paddingInline: 'space.050',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $4857f330d8ce7f4c$export$11dc314b142640a2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "space-between",
        wrap: "wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.025",
        wrap: "wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
        label: "Script footer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $4857f330d8ce7f4c$var$scriptFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $21h3i.messages).loomScriptFooter))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $4857f330d8ce7f4c$var$scriptFooterStyles,
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $21h3i.messages).aiBadgeText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
        label: "AI icon"
    })));
};


const $51432f055686089f$export$2ae663083203d69e = ()=>{
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const showLoomScriptPanel = (0, $gwFzn.useCallback)((onRecordVideoClick)=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).LoomScriptPanel,
            headerComponentElements: {
                HeaderIcon: (0, $f636800745fc6cbd$export$970db1372f5480e2),
                headerLabel: (0, $21h3i.messages).loomScriptTitle
            },
            BodyComponent: ()=>(0, $467a1e0ff151d647$export$d6971ade7b0a7157)({
                    onRecordVideoClick: onRecordVideoClick
                }),
            FooterComponent: (0, $4857f330d8ce7f4c$export$11dc314b142640a2)
        }, 'push');
    }, [
        showObjectSidebar
    ]);
    return {
        isLoomScriptPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).LoomScriptPanel,
        showLoomScriptPanel: showLoomScriptPanel
    };
};


const $6a194b1b69ab8490$export$b86eab19902e37ed = ({ onRecordVideoClick: onRecordVideoClick })=>{
    const { showLoomScriptPanel: showLoomScriptPanel } = (0, $51432f055686089f$export$2ae663083203d69e)();
    const handleClick = ()=>{
        showLoomScriptPanel(onRecordVideoClick);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))),
        onClick: handleClick,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $21h3i.messages).viewScriptButton));
};

});

parcelRegister("DBcPP", function(module, exports) {

$parcel$export(module.exports, "LoomScriptInfoPopup", () => $57e89e06c43dc03b$export$44fb111025082291);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $lGgRw = parcelRequire("lGgRw");

var $21h3i = parcelRequire("21h3i");
const $57e89e06c43dc03b$var$popupContentStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.075',
    paddingInline: 'space.150',
    width: '204px',
    whiteSpace: 'pre-wrap'
});
const $57e89e06c43dc03b$export$44fb111025082291 = ({ trigger: trigger })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const togglePopup = ()=>setIsOpen((prev)=>!prev);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
                xcss: $57e89e06c43dc03b$var$popupContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $21h3i.messages).loomScriptJustification))),
        trigger: (triggerProps)=>trigger({
                isOpen: isOpen,
                togglePopup: togglePopup,
                triggerProps: triggerProps
            })
    });
};

});


//# sourceMappingURL=ReadTimePopup.cdd57810.js.map
